// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"cw-z","smallCardRow":"dw-z","largeCardRow":"ew-z","productSearchRow":"fw-z","curatedRow":"gw-z"};